<template>
  <div v-loading='isHave' element-loading-text="正在检测打印助手或驱动服务是否启动"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <!-- <div class="dz-title">VUE打印测试</div>
    <ul class="dz-opt-group">
      <div class="dz-opt-item">
        <label class="dz-opt-item-title">打印机:</label
        ><select class="dz-opt-item-value" v-model="currPrinter">
          <option
            v-for="item in printers"
            :key="item.title"
            :value="item.value"
          >
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class="dz-opt-item">
        <label class="dz-opt-item-title">纸张类型:</label
        ><select class="dz-opt-item-value" v-model="currGapType">
          <option
            v-for="item in gapTypes"
            :key="item.value"
            :value="item.value"
          >
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class="dz-opt-item">
        <label class="dz-opt-item-title">打印浓度:</label
        ><select class="dz-opt-item-value" v-model="currDarkness">
          <option
            v-for="item in darkness"
            :key="item.value"
            :value="item.value"
          >
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class="dz-opt-item">
        <label class="dz-opt-item-title">打印速度:</label
        ><select class="dz-opt-item-value" v-model="currSpeed">
          <option v-for="item in speeds" :key="item.value" :value="item.value">
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class="dz-opt-item">
        <label class="dz-opt-item-title">打印模式:</label
        ><select class="dz-opt-item-value" v-model="currJobName">
          <option
            v-for="item in jobTypes"
            :key="item.value"
            :value="item.value"
          >
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class="dz-opt-item">
        <label class="dz-opt-item-title">打印方向:</label
        ><select class="dz-opt-item-value" v-model="currOrientation">
          <option
            v-for="item in orientations"
            :key="item.value"
            :value="item.value"
          >
            {{ item.name }}
          </option>
        </select>
      </div>
    </ul>
    <fieldset>
      <legend>打印机相关</legend>
      <ul class="dz-btn-group">
        <a class="button" @click="onOpenPrinter()">打开打印机</a>
        <a class="button" @click="onClosePrinter()">关闭打印机</a>
        <a class="button" @click="onGetPrinterName()">获取打印机名称</a>
        <a class="button" @click="onIsPrinterOpened()">打印机是否打开</a>
        <a class="button" @click="onShowPrinterProperty()">显示打印机属性</a>
      </ul>
    </fieldset> -->
    <div class="printBox">
    <div class="printOption">
    <hr class="hr-twill">
        <ul class="dz-btn-group">
        <el-button class="button" icon='el-icon-circle-close' type='primary' plain size="medium" round @click="printCancel">取消打印</el-button>
        <el-button class="button" :disabled='isDisabled' icon='el-icon-printer' type='primary' plain size="medium" round @click="handleClickPrint" :loading="isloading">确认打印</el-button>
        <!-- <a class="button" @click="onPrintImageData()">打印BASE64(预览)图片</a>
        <a class="button" @click="onPrintJson()">打印JSON绘制任务</a> -->
      </ul>
    </div>
    <hr class="hr-twill2">
    <div class="dz-preview-group" v-loading='isDomLoading' element-loading-text="打印预览页面加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.0)">
      <div class="dz-preview" ref="preview-list"></div>
    </div>
     <hr class="hr-twill">
        <!-- <hr class="hr-double-arrow"> -->
    </div>
  </div>
</template>

<script>
import { DTPWeb, LPA_JobNames, LPA_PrintActions } from "dtpweb";
import { printTemFnMap } from '@/views/custom_data_management/printTemplate/dtpweb'
import axios from 'axios';
import {isLegalPrintApi} from '@/api/manual_label_printing';
import {create} from '@/api/print_logging';


export default {
  name: "App",
  data() {
    return {
      ipUrl:'',
      printTotal:'',
      isDomLoading:false,
      isHave:true,
      isDisabled:true,
      isloading:false,
        printArr:[],
      printers: [{ name: "未检测到打印机", value: {} }],
      currPrinter: { name: "" },
      gapTypes: [
        { name: "随打印机", value: 255 },
        { name: "连续纸", value: 0 },
        { name: "定位孔", value: 1 },
        { name: "间隙纸", value: 2 },
      ],
      currGapType: 255,
      speeds: [
        { name: "随打印机", value: 255 },
        { name: "1(特慢)", value: 0 },
        { name: "2(慢)", value: 1 },
        { name: "3(正常)", value: 2 },
        { name: "4(快)", value: 3 },
        { name: "5(特快)", value: 4 },
      ],
      currSpeed: 255,
      darkness: [
        { name: "随打印机", value: 255 },
        { name: "6(正常)", value: 5 },
        { name: "7", value: 6 },
        { name: "8", value: 7 },
        { name: "9", value: 8 },
        { name: "10(较浓)", value: 9 },
        { name: "11", value: 10 },
        { name: "12", value: 11 },
        { name: "13", value: 12 },
        { name: "14", value: 13 },
        { name: "15(特浓)", value: 14 },
      ],
      currDarkness: 255,
      jobTypes: [
        { name: "打印模式", value: LPA_JobNames.Print },
        { name: "白色底色图片", value: LPA_JobNames.Preview },
        { name: "透明底色图片", value: LPA_JobNames.Transparent },
      ],
      currJobName: LPA_JobNames.Preview,
      orientations: [
        { name: "水平方向", value: 0 },
        { name: "右转90度", value: 90 },
        { name: "180度旋转", value: 180 },
        { name: "左转90度", value: 270 },
      ],
      currOrientation: 0,
      /**
       * @type {DTPWeb | undefined}
       */
      api: undefined,
      showDocument: false,
      jobName: "",
    };
  },
  mounted() {
    
  },
  watch: {
    currPrinter() {
      this.updatePrintParams();
    },
  },
  created () {
    DTPWeb.checkServer({
      showAlert:false,
      downloadUrl: "https://weida.dothantech.com/beta/assets/dtpweb/index.html",
      callback: async (api, server) => {
        this.isHave=false
        this.api = api;
        console.log(`---- ---- check server ---- ----`);
        if(server.statusCode==91){
          if(window.confirm('未检测到打印助手或驱动服务,是否下载该驱动程序?')){
            let a = document.createElement("a");
            //路径中'/'为根目录，即index.html所在的目录
            a.href = "/DL-6800-PrnInst-3.0.2024.0112.exe";
            a.download = "DL-6800-PrnInst-3.0.2024.0112.exe";
            a.click();
          }
         return
        }
        if(server.statusCode==92){
          if(window.confirm('检测到浏览器版本差异,请根据操作引导文档进行设置,是否下载该文档?')){
            let a = document.createElement("a");
            //路径中'/'为根目录，即index.html所在的目录
            a.href = "/operation_guide_document.docx";
            a.download = "操作引导文档.docx";
            a.click();
          }
         return
        }
        console.log(server);
        if (api) {
         this.ipUrl=server.resultInfo.selfIps[0];
         await this.updatePrinterList();
          let printArr=JSON.parse(sessionStorage.getItem('printArr'));
          let obj=this.$cache.local.get("templateData");
            if(printArr){
                this.printArr=[];
                printArr&&printArr.forEach(item=>{
                  if(!obj) return this.printArr.push(printTemFnMap.lyg(item))
                  this.printArr.push(printTemFnMap[obj.templateKey](item))
                })
                if(obj.templateKey==='lyg-gn-szl-1') return this.onPrintJson(this.printArr,{jobWidth: 283,jobHeight: 130,orientation: 0})
                if(obj.templateKey==='lyg-gn-szl-2') return this.onPrintJson(this.printArr,{jobWidth: 193,jobHeight: 90,orientation: 0})
                let standardTem=['lyg','lygSix','lygSeven','lygEight','lygNine','lyg-gn-1'];
                if(standardTem.includes(obj.templateKey)) return this.onPrintJson(this.printArr,{jobWidth: 110,jobHeight: 185,orientation: 0})
                this.onPrintJson(this.printArr)    
            }
        } else {
          if(window.confirm('未检测到打印助手或驱动服务,是否下载该驱动程序?')){
            let a = document.createElement("a");
            //路径中'/'为根目录，即index.html所在的目录
            a.href = "/DL-6800-PrnInst-3.0.2024.0112.exe";
            a.download = "DL-6800-PrnInst-3.0.2024.0112.exe";
            a.click();
          }
          // this.$message({type:'info',message:'未检测到打印助手或驱动服务',offset:95})
          this.printers[0].name = "未检测到打印插件";
        }
      },
    });
    
  },
  methods: {
 handleClickPrint(){
    const values = this.api.getPrinters({onlyOnline:true,onlyLocal:true,onlySupported:true});
    console.log('local',values)
    if(!values.length) return this.$message({type:'warning',message:'请先连接打印机',offset:95})
    if(!(values.some(item=>item.ip===this.ipUrl))) return this.$message({type:'warning',message:'请先连接打印机',offset:95})
    
    this.isloading=true
    const printer = this.printers[0].value;
    console.log(printer)
    this.api?.openPrinter('DL-6800 Label Printer',  (res)=> {
      if(!res) return (this.$message({type:'warning',message:'打印机型号或驱动版本不合法,请联系管理员!',offset:95}),this.isloading=false)
      const value = this.api?.isPrinterOpened();
      if(!value) return (this.$message({type:'error',message:'打印机未打开',offset:95}),this.isloading=false)

      this.$confirm('此次操作打印总数共'+this.printTotal+'页,标签数量是否满足打印需求?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let obj=this.$cache.local.get("templateData");
        let arr=['lyg-gn-szl-1','lyg-gn-szl-2'];
        if(arr.includes(obj.templateKey)) return this.onPrintImageData({orientation:1})
        this.onPrintImageData()
      }).catch(() => {
        this.isloading=false
      });

      // fetch('http://192.168.0.107:10011/api/registry')
      // axios.get('http://'+this.ipUrl+':10011/api/registry')  
      // .then(res=>{  
      //   let result=res.data?.data||null;
      //   if(result){
      //     isLegalPrintApi({...result})
      //     .then(res=>{
      //       if(res){
      //         this.$confirm('此次操作打印总数共'+this.printTotal+'页,标签数量是否满足打印需求?', '提示', {
      //           confirmButtonText: '确定',
      //           cancelButtonText: '取消',
      //           type: 'warning'
      //         }).then(() => {
      //           this.onPrintImageData()
      //         }).catch(() => {
      //           this.isloading=false
      //         });
      //       }else{
      //         this.$message({type:'error',message:'打印机不合法',offset:95})
      //         this.isloading=false;
      //       }
      //     })
      //   }  
      // })  
      // .catch(error=>{  
      //   console.log(error);
      //   this.isloading=false  
      // });

    });
  },
    printCancel(){
      this.api&&this.api.closePrinter();
      window.opener = null;
      window.open("about:blank", "_top").close()
    },
    isPrintJob() {
      return (
        this.currJobName !== LPA_JobNames.Preview &&
        this.currJobName !== LPA_JobNames.Transparent
      );
    },
    getJobAction() {
      if (this.currJobName === LPA_JobNames.Preview)
        return LPA_PrintActions.PrevBase64;
      else if (this.currJobName === LPA_JobNames.Transparent)
        return LPA_PrintActions.TransBase64;
      else return LPA_PrintActions.Print;
    },
    /**
     * 更新打印机列表。
     */
    updatePrinterList() {
      if (!this.api) return;
      //
      const api = this.api;
      //
      const values = api.getPrinters();
      // 清空旧打印机列表
      this.printers.splice(0);
      //
      if (values?.length > 0) {
        for (const item of values) {
          const title = api.isLocalPrinter(item)
            ? item.name
            : `${item.name}@${item.ip}`;
          this.printers.push({
            name: title,
            value: item,
          });
        }
        //
        this.currPrinter = values[0];
        console.log(this.currPrinter)
      } else {
        this.printers.push({ name: "未检测到打印机", value: "" });
      }
    },
    /**
     * 获取并更新打印参数
     */
    updatePrintParams() {
      if (!this.api) return;
      //
      this.api.openPrinter(this.currPrinter, (success) => {
        if (success) {
          this.currGapType = this.api.getGapType();
          this.currDarkness = this.api.getPrintDarkness();
          this.currSpeed = this.api.getPrintSpeed();
          //
          this.api.closePrinter();
        }
      });
    },
    /**
     * 打开打印机测试
     */
    onOpenPrinter() {
      const printer = this.printers[0].value;
      this.api?.openPrinter(printer, function (value) {
        alert(value ? "打印机打开成功!" : "打印机打开失败");
      });
    },
    /**
     * 关闭打印机测试
     */
    onClosePrinter() {
      this.api.closePrinter();
    },
    /**
     * 获取打印机名称
     */
    onGetPrinterName() {
      if (this.api?.isPrinterOpened()) {
        const name = this.api.getPrinterName();
        alert(name);
      } else {
        alert("打印机未连接");
      }
    },
    /**
     * 检测打印机是否打开
     */
    onIsPrinterOpened() {
      const value = this.api?.isPrinterOpened();
      alert(value);
    },
    /**
     * 显示打印机首选项/属性
     */
    onShowPrinterProperty() {
      // 打印机首选项与打印机属性交替显示。
      this.api.showProperty({ showDocument: this.showDocument });
      // 切换下次的显示状态。
      this.showDocument = !this.showDocument;
    },
    openPrinter(callback) {
      if (this.api) {
        this.api.openPrinter(this.currPrinter, callback);
      } else if (callback) {
        callback(false);
      }
    },
    /**
     * 直接打印BASE64图片测试
     */
    onPrintImageData(params={}) {
      /**
       * @type {HTMLElement}
       */
      const datas = this.$refs["preview-list"];
      if (datas && datas.childNodes) {
        const childNodes = datas.childNodes;
        for (let i = 0; i < childNodes.length; i++) {
          if (childNodes[i].src) {
            console.log(this.api.printImage)
            this.api.printImage({
              data: childNodes[i].src,
              printerName: this.currPrinter?.name,
              orientation:params.orientation||0,
              callback:(res)=>{
                // console.log(res)
                // if(res) this.$message({type:'success',message:'提交打印任务成功',offset:95})
              }
            })
          }
        }
        this.$message({type:'success',message:'提交打印任务成功',offset:95})
        let printerParams=JSON.parse(sessionStorage.getItem('printerParams'));
        create(printerParams)
        .then(res=>{
          console.log(res)
        })
        this.isloading=false
      }
    },
    /**
     * 打印JSON格式绘制任务。
     */
    onPrintJson(jobPages,jobInfo=null) {
      this.isDomLoading=true
      const printerName = this.currPrinter ? this.currPrinter.name : undefined;
      if (this.isPrintJob() && !printerName) return;
      //
      const printAction = this.getJobAction();
      const labelWidth = 110;
      const labelHeight = 275;
      // var url = 'http://www.detonger.com/img/QRCode_OfficialAccounts.png';
      // var text1 = '上海道臻信息技术有限公司';
      // var text2 = '1234567';
      this.api.print({
        action: printAction,
        printerInfo: {
          printerName: this.currPrinter.name,
        },
        jobInfo:jobInfo || {
          jobWidth: labelWidth,
          jobHeight: labelHeight,
          orientation: 0
        },
        jobPages:jobPages||this.printArr,
        // jobPages: [
        //   // 第一张标签，外边框里面套个二维码
        //   [
        //     //矩形
        //     {
        //       type: "rectangle",
        //       width: labelWidth,
        //       height: 160,
        //       lineWidth: 0.4,
        //       y:5
        //     },
        //     //线条
        //     { type: 'line', x1: 0, y1: 25, x2: labelWidth, y2: 25, lineWidth: 0.4 },
        //     { type: 'line', x1: 0, y1: 45, x2: labelWidth, y2: 45, lineWidth: 0.4 },
        //     { type: 'line', x1: 0, y1: 65, x2: labelWidth, y2: 65, lineWidth: 0.4 },
        //     { type: 'line', x1: 0, y1: 85, x2: labelWidth, y2: 85, lineWidth: 0.4 },
        //     { type: 'line', x1: 0, y1: 105, x2: labelWidth, y2: 105, lineWidth: 0.4 },
        //     { type: 'line', x1: 0, y1: 125, x2: labelWidth, y2: 125, lineWidth: 0.4 },
        //     { type: 'line', x1: 0, y1: 145, x2: labelWidth, y2: 145, lineWidth: 0.4 },
        //     { type: 'line', x1: 20, y1: 165, x2: 20, y2: 25, lineWidth: 0.4 },
        //     //标题
        //     { type: 'text', text: '物资卡片', width: 90, height: 20, fontHeight: 4 ,verticalAlignment:1,horizontalAlignment:1,y:5},
        //       { type: 'text', text: '物料编码', width: 20, height: 20, fontHeight: 4 ,verticalAlignment:1,horizontalAlignment:1,y:25},
        //       { type: 'text', text: '批次号', width: 20, height: 20, fontHeight: 4 ,verticalAlignment:1,horizontalAlignment:1,y:45},
        //       { type: 'text', text: '物料描述', width: 20, height: 20, fontHeight: 4 ,verticalAlignment:1,horizontalAlignment:1,y:65},
        //       { type: 'text', text: '计量单位', width: 20, height: 20, fontHeight: 4 ,verticalAlignment:1,horizontalAlignment:1,y:85},
        //       { type: 'text', text: '物资数量', width: 20, height: 20, fontHeight: 4 ,verticalAlignment:1,horizontalAlignment:1,y:105},
        //       { type: 'text', text: '库位', width: 20, height: 20, fontHeight: 4 ,verticalAlignment:1,horizontalAlignment:1,y:125},
        //       { type: 'text', text: '备注', width: 20, height: 20, fontHeight: 4 ,verticalAlignment:1,horizontalAlignment:1,y:145},
        //       //内容
        //       // { type: 'text', text: '物资卡片', width: 90, height: 20, fontHeight: 4 ,verticalAlignment:1,horizontalAlignment:1,y:5,x:20},
        //       { type: 'text', text: '物料编码', width: 70, height: 20, fontHeight: 4 ,verticalAlignment:1,horizontalAlignment:1,y:25,x:20},
        //       { type: 'text', text: '批次号', width: 70, height: 20, fontHeight: 4 ,verticalAlignment:1,horizontalAlignment:1,y:45,x:20},
        //       { type: 'text', text: '物料描述', width: 70, height: 20, fontHeight: 4 ,verticalAlignment:1,horizontalAlignment:1,y:65,x:20},
        //       { type: 'text', text: '计量单位', width: 70, height: 20, fontHeight: 4 ,verticalAlignment:1,horizontalAlignment:1,y:85,x:20},
        //       { type: 'text', text: '物资数量', width: 70, height: 20, fontHeight: 4 ,verticalAlignment:1,horizontalAlignment:1,y:105,x:20},
        //       { type: 'text', text: '库位', width: 70, height: 20, fontHeight: 4 ,verticalAlignment:1,horizontalAlignment:1,y:125,x:20},
        //       { type: 'text', text: '备注', width: 70, height: 20, fontHeight: 4 ,verticalAlignment:1,horizontalAlignment:1,y:145,x:20},
        //     // { type: 'roundRectangle', width: labelWidth, height: labelHeight, lineWidth: 0.4, cornerWidth: 2 },
        //     // {
        //     //   type: "barcode",
        //     //   text: "12345678",
        //     //   x: 5,
        //     //   y: 5,
        //     //   width: 30,
        //     //   height: 20,
        //     //   textHeight: 4,
        //     //   textAlignment: 3,
        //     // },
              
        //     // { type: 'qrcode', text: text1, x: 10, y: 5, width: 20, eccLevel: 1 },
        //     // { type: 'pdf417', text: text2, x: 5, y: 5, width: 30, height: 20 },
        //     // // 绘制图片url
        //     // { type: 'image', imageFile: url, x: 10, y: 5, width: 20, height: 20 },
        //     // // 绘制BASE64字符串
        //     // { type: 'image', imageFile: imgSrc, x: 10, y: 5, width: 20, height: 20 },
            
        //     // { type: 'dashLine', x1: 0, y1: 10, x2: labelWidth, y2: 10, lineWidth: 0.4, dashLen: '1,0.5' },
        //   ],
        // ],
        callback: (results) => {
          // 先清空预览区域；
          this.$refs["preview-list"].innerHTML = "";
          // 显示预览效果
          if (printAction !== 0x1000 && results) {
            this.previewPages(results.previewData);
          }
        },
      });
    },
    addPreview(data,totalLength) {
      if (!data) return;
      let imgWidth=432;
      let obj=this.$cache.local.get("templateData");
      let arr=['lyg-gn-szl-1','lyg-gn-szl-2'];
      if(arr.includes(obj.templateKey)){
        imgWidth=765;
      }
      const previewGroup = this.$refs["preview-list"];
      const img = document.createElement("img");
      img.src = data;
      img.title='当前页数第'+((previewGroup.children.length/2+1))+'页,共'+totalLength+'页';
      img.width=imgWidth;
      img.style.padding='20px';
      img.style.paddingTop='0';
      img.style.backgroundColor='white';
      previewGroup.appendChild(img);
      // 换行
      previewGroup.appendChild(document.createElement("br"));
    },
    /**
     * 获取当前任务的图片信息；
     */
    previewJobs() {
      // 先清空预览区域；
      this.$refs["preview-list"].innerHTML = "";

      // 现获取当前打印任务的页数，然后遍历页面图片；
      const info = this.api.getPageInfo();
      // 遍历所有页面数据，然后添加到预览区域
      if (info) {
        const pages = [];
        for (let i = 0; i < info.pages; i++) {
          const page = this.api.getPageImage({ page: i });
          pages.push(page.data);
        }
        this.previewPages(pages);
      }
    },
    previewPages(pages) {
      this.printTotal=pages.length;
      if (pages && pages.length > 0) {
        for (const page of pages) {
          this.addPreview(page,pages.length);
        }
        this.isDisabled=false
        this.isDomLoading=false
      }
    },
    /**
     * 获取 #preview-list中所有img的src；
     */
    getPreviewList() {
      const previewGroup = this.$refs["preview-list"];
      const pageList = [];
      for (let i = 0; i < previewGroup.children.length; i++) {
        const imgElement = previewGroup.children[i];
        if (imgElement?.src) pageList.push(imgElement.src);
      }

      return pageList;
    },
    pix2mm(pxValue, printDpi) {
      printDpi = printDpi || 203;
      return (pxValue * 25.4) / printDpi;
    },
  },
};
</script>

<style lang="scss" scoped>
html,body,div{
    height: 100%;
    margin: 0;
    padding: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
body {
    text-align: center;
}
.dz-title {
    font-weight: bold;
    font-size: 20px;
}
.dz-opt-group .dz-opt-item {
    display: flex;
    width: 400px;
    height: 28px;
    margin: 0 auto 10px auto;
}
.dz-opt-group .dz-opt-item .dz-opt-item-title {
    flex: 2;
    display: inline-block;
    text-align: right;
    background-color: lightblue;
    // margin: 5px;
    padding: 5px;
}
.dz-opt-group .dz-opt-item .dz-opt-item-value {
    flex: 5;
    background-color: lightyellow;
    max-width: 280px;
}
fieldset {
    width: 50%;
    margin: auto;
    min-height: 50px;
}
a {
    color: #42b983;
    cursor: pointer;
}
.button {
    cursor: pointer;
    // padding: 0.4em 2em !important;
    margin: 0.25em 0.5em;
    border-radius: 0.5em;
    display: inline-block;
    transition: all 0.15s ease;
    box-sizing: border-box;
    // border: 1px solid #4fc08d;
}
.dz-btn-group {
    text-align: center;
    margin: 0;
}
.dz-btn-group .button {
    display: inline-block;
    width: 250px;
    margin: 10px 5px 0 5px;
}
.dz-preview-group {
  user-select: none;
  padding-top: 5px;
    background-color: gray;
    height: calc(100vh - 161px);
    overflow-y: scroll;
    display: flex;
    justify-content: center;
    align-items: center;
}
.printBox{
    height: 100%;
    overflow: hidden;
    .printOption{
        // margin: 20px;
        height: 120px;
        .dz-btn-group{
           margin-top: 30px;
        }
    }
}
img:nth-last-of-type(1){
margin-bottom: 10px;
}
// .hr-double-arrow {
//     color: #d0d0d5;
//     border: double;
//     border-width: 3px 5px;
//     border-color: #d0d0d5 transparent;
//     height: 1px;
//     overflow: visible;
//     margin-left: 20px;
//     margin-right: 20px;
//     position: relative;
// }
// .hr-double-arrow:before, 
// .hr-double-arrow:after {
//     content: '';
//     position: absolute;
//     width: 5px; height: 5px;
//     border-width: 0 3px 3px 0;
//     border-style: double;
//     top: -3px;
//     background: radial-gradient(2px at 1px 1px, currentColor 2px, transparent 0) no-repeat;
// }
// .hr-double-arrow:before {
//     transform: rotate(-45deg);
//     left: -20px;
// }
// .hr-double-arrow:after {
//     transform: rotate(135deg);
//     right: -20px;
// }
.hr-twill {
    border: 0;
    padding: 3px;
    background: repeating-linear-gradient(135deg, #7bc8d9 0px, #F2FCFE 1px, transparent 1px, transparent 6px);
}
.hr-twill:after{
  content:"打印操作区域";
  font-size:18px;
  background:#5FD4F0;
  z-index:2;
  position: absolute;
  left: 300px;
  top: 0;
  color: white;
  padding:10px 30px;
  // border: 1px solid gray;
   border-radius: 0 0 1em 1em;
}
.hr-twill2 {
    border: 0;
    padding: 3px;
    background: repeating-linear-gradient(135deg, #7bc8d9 0px, #F2FCFE 1px, transparent 1px, transparent 6px);
}
.hr-twill2:after{
  content:"打印预览视图";
  font-size:18px;
  background:gray;
  z-index:2;
  position: absolute;
  right: 300px;
  top: 106px;
  color: white;
  padding:10px 30px;
  // border: 1px solid gray;
  border-radius: 1em 1em 0 0;
}
// .hr-mid-border-content::after{
//     content: attr(data-content);
//     position: absolute;
//     padding: 4px 1ch;
//     top: 50%; left: 50%;
//     transform: translate(-50%, -50%);
//     color: transparent;
//     border: 1px solid #d0d0d5;
// }
/* .addEdit .el-dialog {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0px !important;
} */
/* .ReadSendObject .el-dialog {
  left: 50%;
  top: 17%;
  transform: translate(-50%, -17%);
  margin: 0px !important;
} */
/* 美化滚动条 */
body {
  margin: 0;
  overflow: overlay;
}
::-webkit-scrollbar {
  background-color: transparent;
  width: 12px;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  background-clip: content-box;
  border: 2px solid transparent;
}
body[scroll]::-webkit-scrollbar-thumb,
::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
